var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "centralized rounded-container" },
    [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "el-button",
            {
              staticClass: "add-button",
              on: {
                click: function($event) {
                  return _vm.openModal("add")
                }
              }
            },
            [_c("span", [_vm._v("Adicionar UPFPA")])]
          )
        ],
        1
      ),
      _c(
        "h2",
        {
          staticStyle: {
            "border-bottom": "1px solid #ccc",
            "padding-bottom": "10px"
          }
        },
        [_vm._v("UPF por Ano")]
      ),
      _c(
        "el-table",
        { staticStyle: { width: "200%" }, attrs: { data: _vm.upf } },
        [
          _c("el-table-column", {
            attrs: { label: "Ano", width: "auto", prop: "ano" }
          }),
          _c("el-table-column", {
            attrs: {
              label: "Ajuste Monetário (UPFPA)",
              width: "auto",
              prop: "valor"
            }
          }),
          _c("el-table-column", {
            attrs: { label: "ifd 1", prop: "ifd1", sortable: "sortable" }
          }),
          _c("el-table-column", {
            attrs: {
              label: "ifd 2",
              prop: "ifd2",
              "min-width": "100",
              sortable: "sortable"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: "Taxa Juros PF",
              prop: "taxaJuros",
              "min-width": "100",
              sortable: "sortable"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: "Taxa Juros PJ",
              prop: "taxaJurosPj",
              "min-width": "100",
              sortable: "sortable"
            }
          }),
          _c("el-table-column", {
            attrs: { label: "Ações" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-dropdown",
                      { attrs: { trigger: "click", size: "small" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "el-dropdown-link",
                            attrs: { type: "primary", size: "mini" }
                          },
                          [
                            _c("span", [_vm._v("Ações")]),
                            _c("i", {
                              staticClass: "el-icon-arrow-down el-icon--right"
                            })
                          ]
                        ),
                        _c(
                          "el-dropdown-menu",
                          {
                            style: {
                              cursor: _vm.isCurrentYear(scope.row.ano)
                                ? "not-allowed"
                                : "pointer"
                            }
                          },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  disabled: _vm.isCurrentYear(scope.row.ano)
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.editUpf(scope.row)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-edit" }),
                                    _c("span", [_vm._v("Editar")])
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "custom-dialog",
          attrs: {
            visible: _vm.isModalOpen,
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.isModalOpen = $event
            }
          }
        },
        [
          _c("div", { staticClass: "custom-dialog-header" }, [
            _c("span", { staticClass: "el-dialog__title" }, [
              _vm._v(_vm._s(_vm.modalTitle))
            ])
          ]),
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  _vm.isAdding ? _vm.addUpf() : _vm.updateUpf()
                }
              }
            },
            [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Ano:    *")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newUpf.ano,
                        expression: "newUpf.ano"
                      }
                    ],
                    staticClass: "borda-input-ano",
                    style: {
                      cursor: _vm.disableAnoInput ? "not-allowed" : "auto"
                    },
                    attrs: {
                      disabled: _vm.disableAnoInput,
                      required: "required"
                    },
                    domProps: { value: _vm.newUpf.ano },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.newUpf, "ano", $event.target.value)
                      }
                    }
                  })
                ]),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Ajuste Monetário (UPFPA):    *")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newUpf.valor,
                        expression: "newUpf.valor"
                      }
                    ],
                    staticClass: "borda-input",
                    attrs: { required: "required" },
                    domProps: { value: _vm.newUpf.valor },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.newUpf, "valor", $event.target.value)
                      }
                    }
                  })
                ]),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("ifd 1:    *")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newUpf.ifd1,
                        expression: "newUpf.ifd1"
                      }
                    ],
                    staticClass: "borda-input",
                    attrs: { required: "required" },
                    domProps: { value: _vm.newUpf.ifd1 },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.newUpf, "ifd1", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("ifd 2:    *")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newUpf.ifd2,
                        expression: "newUpf.ifd2"
                      }
                    ],
                    staticClass: "borda-input",
                    attrs: { required: "required" },
                    domProps: { value: _vm.newUpf.ifd2 },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.newUpf, "ifd2", $event.target.value)
                      }
                    }
                  })
                ]),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Taxa Juros PF:    *")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newUpf.taxaJuros,
                        expression: "newUpf.taxaJuros"
                      }
                    ],
                    staticClass: "borda-input",
                    attrs: { required: "required" },
                    domProps: { value: _vm.newUpf.taxaJuros },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.newUpf, "taxaJuros", $event.target.value)
                      }
                    }
                  })
                ]),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Taxa Juros PJ:    *")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newUpf.taxaJurosPj,
                        expression: "newUpf.taxaJurosPj"
                      }
                    ],
                    staticClass: "borda-input",
                    attrs: { required: "required" },
                    domProps: { value: _vm.newUpf.taxaJurosPj },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.newUpf, "taxaJurosPj", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _c(
                "div",
                { staticClass: "custom-dialog-footer" },
                [
                  _c("el-button", { on: { click: _vm.buttonCancelar } }, [
                    _c("span", [_vm._v("Cancelar")])
                  ]),
                  _vm.isAdding
                    ? _c(
                        "el-button",
                        {
                          staticClass: "salvar",
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.addUpf()
                            }
                          }
                        },
                        [_c("span", [_vm._v("Salvar")])]
                      )
                    : _c(
                        "el-button",
                        {
                          style: {
                            cursor: _vm.isCurrentYear(_vm.newUpf.ano)
                              ? "not-allowed"
                              : "pointer"
                          },
                          attrs: { type: "primary" },
                          on: { click: _vm.buttonAlterar }
                        },
                        [_c("span", [_vm._v("Alterar")])]
                      )
                ],
                1
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e20d1172", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e20d1172","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/financeiro/upfpa/processoUpfpa.vue
// module id = null
// module chunks = 